'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
require('react');
var PropTypes = require('prop-types');
var require$$0 = require('deepmerge');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);

/* eslint-disable max-len */

/**
 * Non-branded section of the config serves as default config.
 * If values don't change by brand and you want to add them, you can also add them as default config.
 * Any config values added under a brand represent an override of that brand value.
 *
 * Feature Flags: use feature flag, "isEnabled", to conditionally render everything based on brand.
 * Ex. { isEnabled: false } as defualt and { isEnabled: true } under the brands allows us
 * to render components like so: {featureFlag && <Component />} for specific brand(s).
 *
 * Any values associated with a particular component should exist under that component key (ex. rateAppBannerBanner).
 *
 * These steps also prevent config value duplication and setting values to '' or null, just to avoid
 * breaking the config.
 *
 * For more, visit "theme-config.js" section of README.stories.mdx.
 */
var themeConfig$1 = {
  branchHeroImageWidth: 200,
  loHeroAndLoNavigation: {
    applyCTA: 'Apply Now',
    applyCTASpanish: 'Aplica Ahora',
    scheduleCTA: 'Schedule a conversation',
    scheduleCTASpanish: 'Programar Cita',
    heroImageDefaultWidth: 200,
    heroImageFixedHeight: 280
  },
  loListingHeader: {
    listingImageDefaultWidth: 60,
    listingImageFixedHeight: 84
  },
  minimalHeader: {
    isEnabled: false
  },
  rateAppBanner: {
    isEnabled: false
  },
  mortgageCalculatorLite: {
    isEnabled: true,
    defaultCalculatorSettings: {
      purchasePrice: 300000,
      downPayment: 60000,
      downPaymentPercent: 20,
      interestRate: '6.42',
      loanTerm: 30,
      militaryVeteran: false
    },
    mortgageCalculatorLiteCtaButtonText: 'Personalize my estimate'
  },
  sameDayBanner: {
    isEnabled: true,
    sameDayBannerWidth: '57rem',
    sameDayBannerDesktopImageUrl: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blteb2d0d769939d98a/65666daf1204cd54d9ca6346/PowerBid_Couple.webp',
    sameDayBannerDesktopImageHeight: 240,
    sameDayBannerDesktopImageWidth: 346,
    sameDayBannerHeading: 'Get approved in one day',
    sameDayBannerParagraph: 'The competitive edge you need to purchase the home you want. Get a fast approval with options as little as 3% down.',
    sameDayBannerCtaText: 'Let\'s go',
    sameDayBannerPadding: 'var(--space-xy-xxSmall-rem)',
    sameDayBannerBrandLogo: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt52c2b071c8ac8d0f/64cc3094bfb67169ce6bf3dd/samedaylogo.png',
    sameDayBannerBrandLogoHeight: 60,
    sameDayBannerBrandLogoWidth: 60,
    sameDayBannerSplitColor: 'var(--color-marketing-6-lighter)',
    sameDayBannerBgColor: 'var(--color-marketing-2-base)',
    sameDayBannerCorners: false
  },
  helocBanner: {
    isEnabled: true,
    helocBannerWidth: '57rem',
    helocBannerPadding: 'var(--space-xy-xxSmall-rem)',
    helocBannerParagraph: 'Our Home Equity Line of Credit can help you fund home improvements & consolidate debt.',
    helocBannerIconName: 'arrow-right',
    helocBannerHeadingVariant: 'h3',
    helocBannerBgColor: 'var(--color-marketing-7-base)',
    helocBannerHeading: 'A HELOC with a fixed rate just for you.',
    helocBannerCtaColor: 'var(--color-marketing-7-base)',
    helocBannerHeadingFontSize: 'var(--font-size-s)'
  },
  personalLoanBanner: {
    isEnabled: true,
    personalLoanBannerWidth: '57rem',
    personalLoanBannerPadding: 'var(--space-xy-xxSmall-rem)',
    personalLoanBannerIconName: 'arrow-right',
    personalLoanBannerHeadingVariant: 'h3',
    personalLoanBannerBgColor: 'var(--color-marketing-7-base)',
    personalLoanBannerHeading: 'Get a personal loan.',
    personalLoanBannerCtaColor: 'var(--color-marketing-7-base)',
    personalLoanBannerDisclaimer: null,
    personalLoanBannerRedirectionPath: 'personal-loans',
    personalLoanBannerHeadingFontSize: 'var(--font-size-s)'
  },
  qrCodeHero: {
    isEnabled: false
  },
  loGrid: {
    maxToShow: 6,
    defaultImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltc442044c29806346/64baec1e320b7e4cbfca78c7/defaultProfileImage.jpg'
  },
  carousel: {
    isEnabled: true
  },
  mortgageCalculatorTile: {
    mortgageCalculatorTileUrl: '/mortgage-calculators',
    isEnabledOnVpPage: true,
    isEnabledOnBranchPage: true
  },
  firstTimeHomeBuyerTile: {
    firstTimeHomeBuyerTileUrl: '/fthb-guide',
    isEnabledOnVpPage: true,
    isEnabledOnBranchPage: true
  },
  enterpriseNav: {
    showLanguageButtonOnVpAndBranchPages: false
  },
  hasSpanishDM: false,
  gri: {
    branchImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt6db87d5552dced89/6495dffffcb6fd83d75ab71e/branch-image.jpg',
    heroImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt6db87d5552dced89/6495dffffcb6fd83d75ab71e/branch-image.jpg',
    carousel: {
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate',
        link: '/resources/home-down-payment-assistance'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down',
        link: '/resources/average-down-payment-for-a-house'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember',
        link: '/mortgage-rates/assumptions/va_30-year_fixed_conforming'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo',
        link: '/home-loans/jumbo-mortgage'
      }, {
        title: 'Lock in your rate',
        content: 'Lock ‘N’ Roll: Lock in a mortgage rate for 60, 75, or 90 days without a signed contract. Secure a lower rate while house shopping with this program.',
        iconName: 'performance-bar-percent',
        link: '/lock-n-roll'
      }, {
        title: 'Accelerated timelines',
        content: 'Our Same-Day program facilitates you to get your loan approved in one day with options as little as 3% down.',
        iconName: 'performance-path',
        link: '/same-day-mortgage'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health',
        link: '/resources/doctor-program'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }, {
        title: 'Reverse Mortgages',
        content: 'A great option for homeowners over 62 who need additional income to supplement their retirement income or pay for long-term care.',
        iconName: 'money-hold',
        link: '/reverse-mortgage'
      }]
    },
    rateAppBanner: {
      isEnabled: true,
      rateAppBannerImageHeight: 232,
      rateAppBannerImageWidth: 530,
      rateAppBannerBackgroundImage: {
        desktop: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltd97bc6ec8bb5160d/65665cd08d10922afc56bff8/rate-app-background.webp',
          height: 232,
          width: 912
        },
        mobile: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt30890a838ad947c3/656661bd5af5391e8659f669/rate-app-background-mobile.webp',
          height: 312,
          width: 344
        }
      },
      rateAppBannerRateLogo: {
        desktop: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blte08c31bfeb347f39/65027cfd9bcd1bdc631d027c/5min_rateLogo.svg',
          height: 35,
          width: 88
        },
        mobile: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blte08c31bfeb347f39/65027cfd9bcd1bdc631d027c/5min_rateLogo.svg',
          height: 27,
          width: 67
        }
      },
      rateAppBannerRateLogoAltText: 'Rate Logo',
      rateAppBannerAltText: 'Discover Our App Download Page',
      rateAppBannerGoogleStoreBadge: {
        desktop: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt291bee008bdfb0d6/651adef4964d9bb339c30eec/Google_Play_Badge_Light@2x.png',
          height: 35,
          width: 117
        },
        mobile: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt41d12081e1ba8671/651adf015554e9065463c510/Google_Play_Badge_Dark@2x.png',
          height: 42,
          width: 143
        }
      },
      rateAppBannerAppleStoreBadge: {
        desktop: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt38efd133d8edf312/651adeea375d982d279cd722/App_Store_Badge_Light@2x.png',
          height: 35,
          width: 104
        },
        mobile: {
          url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltc7af5b515d2a3c59/651adf08964d9baee3c30ef0/App_Store_Badge_Dark@2x.png',
          height: 48,
          width: 143
        }
      },
      rateAppBannerQrCode: {
        desktop: {
          height: 128,
          width: 128
        },
        mobile: {
          height: 96,
          width: 96
        }
      }
    },
    qrCodeHero: {
      isEnabled: true
    },
    mortgageCalculatorLite: {
      isEnabled: false
    },
    hasSpanishDM: true,
    personalLoanBanner: {
      personalLoanBannerParagraph: 'Get the extra financial help you need. Apply in Minutes, get your funds in days.'
    }
  },
  gra: {
    useMinimalHeader: true,
    branchImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltfc8d999aa9ed4bf2/64b58afde97bb8dbc942b504/gra-branch-image.jpg',
    heroImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltfc8d999aa9ed4bf2/64b58afde97bb8dbc942b504/gra-branch-image.jpg',
    branchHeroImageWidth: 233,
    minimalHeader: {
      isEnabled: true,
      logoSrc: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blte2241c03634be37c/646befbd46d4d8ed366be4c2/GRA_Logo.svg',
      logoAlt: 'Guaranteed Rate Affinity Logo',
      logoHeight: 45,
      logoWidth: 167,
      links: [{
        desktop: {
          linkName: 'Login',
          linkUrl: 'https://login.grarate.com'
        },
        mobile: {
          linkName: 'Login',
          linkUrl: 'https://login.grarate.com'
        }
      }]
    },
    personalLoanBanner: {
      personalLoanBannerParagraph: 'Powered by our affiliate partner, Rate, Inc. This is a loan product referral and not offered by Guaranteed Rate Affinity',
      personalLoanBannerRedirectionPath: 'lp/personal-loans-gra'
    },
    carousel: {
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate',
        link: '/article/home-down-payment-assistance'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down',
        link: '/article/average-down-payment-for-a-house'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember',
        link: '/mortgage-rates/assumptions/va_30-year_fixed_conforming'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo',
        link: '/home-loans/jumbo-mortgage'
      }, {
        title: 'Lock in your rate',
        content: 'Lock ‘N’ Roll: Lock in a mortgage rate for 60, 75, or 90 days without a signed contract. Secure a lower rate while house shopping with this program.',
        iconName: 'performance-bar-percent',
        link: '/lock-n-roll'
      }, {
        title: 'Accelerated timelines',
        content: 'Our Same-Day program facilitates you to get your loan approved in one day with options as little as 3% down.',
        iconName: 'performance-path',
        link: '/same-day-mortgage'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health',
        link: '/article/doctor-program'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }]
    },
    mortgageCalculatorTile: {
      isEnabledOnVpPage: false
    },
    mortgageCalculatorLite: {
      mortgageCalculatorLiteDisclaimerText: "\n        <p>*This is not a commitment to lend. Consumers are advised to obtain a Loan Estimate. Rates are subject to change and are dependent on\n        credit and underwriting criteria.</p>\n\n        <p>Your actual rate, payment and costs could be higher. Guaranteed Rate Affinity cannot predict where rates\n        will be in the future. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other financial\n        advice specific to the circumstances of any individual and should not be relied upon in that regard. Applicant subject to credit and\n        underwriting approval. Not all applicants will be approved for financing. Receipt of application does not represent an approval for\n        financing or interest rate guarantee. Restrictions may apply, contact Guaranteed Rate Affinity for current\n        rates and for more information. All information provided in this publication is for informational and educational purposes only, and in\n        no way is any of the content contained herein to be construed as financial, investment,or legal advice or instruction.\n        Guaranteed Rate Affinity does not guarantee the quality, accuracy, completeness or timelines of the\n        information in this publication. While efforts are made to verify the information provided, the information should not be assumed to\n        be error free. Some information in the publication may have been provided by third parties and has not necessarily been verified by\n        Guaranteed Rate Affinity. Guaranteed Rate Affinity its affiliates and\n        subsidiaries do not assume any liability for the information contained herein, be it direct, indirect, consequential, special, or\n        exemplary, or other damages whatsoever and howsoever caused, arising out of or in connection with the use of this publication or in\n        reliance on the information, including any personal or pecuniary loss, whether the action is in contract, tort (including negligence)\n        or other tortious action. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other\n        financial advice specific to the circumstances of any individual and should not be relied upon in that regard.</p>\n      "
    }
  },
  prate: {
    useMinimalHeader: true,
    branchImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltfc8d999aa9ed4bf2/64b58afde97bb8dbc942b504/gra-branch-image.jpg',
    heroImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt1587b4c1dbe22a30/64b58db3fae2aca97dbaf9d9/prate-branch-image.webp',
    branchHeroImageWidth: 420,
    minimalHeader: {
      isEnabled: true,
      logoSrc: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltcd2fb82e218f6396/646bf294c24d6c581f66d124/PRATE_Logo.png',
      logoAlt: 'Proper Rate A Rate Company Logo',
      logoHeight: 55,
      logoWidth: 167,
      backgroundColor: 'var(--color-marketing-1-lighter)',
      links: [{
        desktop: {
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'LOG IN',
          linkUrl: 'https://login.properrate.com/'
        }
      }, {
        mobile: {
          fontWeight: 'var(--font-weight-bold)',
          iconName: 'user',
          linkName: '',
          linkUrl: 'https://login.properrate.com/'
        }
      }]
    },
    personalLoanBanner: {
      personalLoanBannerParagraph: 'Powered by our affiliate partner, Rate, Inc. This is a loan product referral and not offered by Proper Rate',
      personalLoanBannerRedirectionPath: 'lp/personal-loans-pr'
    },
    carousel: {
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate',
        link: '/article/home-down-payment-assistance'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down',
        link: '/article/average-down-payment-for-a-house'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember',
        link: '/mortgage-rates/assumptions/va_30-year_fixed_conforming'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo',
        link: '/home-loans/jumbo-mortgage'
      }, {
        title: 'Lock in your rate',
        content: 'Lock ‘N’ Roll: Lock in a mortgage rate for 60, 75, or 90 days without a signed contract. Secure a lower rate while house shopping with this program.',
        iconName: 'performance-bar-percent',
        link: '/lock-n-roll'
      }, {
        title: 'Accelerated timelines',
        content: 'Our Same-Day program facilitates you to get your loan approved in one day with options as little as 3% down.',
        iconName: 'performance-path',
        link: '/same-day-mortgage'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health',
        link: '/article/doctor-program'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }]
    },
    mortgageCalculatorTile: {
      isEnabledOnVpPage: false
    },
    mortgageCalculatorLite: {
      mortgageCalculatorLiteDisclaimerText: "\n        <p>*This is not a commitment to lend. Consumers are advised to obtain a Loan Estimate. Rates are subject to change and are dependent on\n        credit and underwriting criteria.</p>\n\n        <p>Your actual rate, payment and costs could be higher. Proper Rate cannot predict where rates\n        will be in the future. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other financial\n        advice specific to the circumstances of any individual and should not be relied upon in that regard. Applicant subject to credit and\n        underwriting approval. Not all applicants will be approved for financing. Receipt of application does not represent an approval for\n        financing or interest rate guarantee. Restrictions may apply, contact Proper Rate for current\n        rates and for more information. All information provided in this publication is for informational and educational purposes only, and in\n        no way is any of the content contained herein to be construed as financial, investment,or legal advice or instruction.\n        Proper Rate does not guarantee the quality, accuracy, completeness or timelines of the\n        information in this publication. While efforts are made to verify the information provided, the information should not be assumed to\n        be error free. Some information in the publication may have been provided by third parties and has not necessarily been verified by\n        Proper Rate. Proper Rate its affiliates and\n        subsidiaries do not assume any liability for the information contained herein, be it direct, indirect, consequential, special, or\n        exemplary, or other damages whatsoever and howsoever caused, arising out of or in connection with the use of this publication or in\n        reliance on the information, including any personal or pecuniary loss, whether the action is in contract, tort (including negligence)\n        or other tortious action. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other\n        financial advice specific to the circumstances of any individual and should not be relied upon in that regard.</p>\n      "
    }
  },
  op: {
    useMinimalHeader: true,
    branchImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt64ccc5340f9af7c2/64b58dfc9228cdcde97fe6ac/op-branch-image.webp',
    heroImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt64ccc5340f9af7c2/64b58dfc9228cdcde97fe6ac/op-branch-image.webp',
    branchHeroImageWidth: 200,
    minimalHeader: {
      isEnabled: true,
      logoSrc: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blte7a43919fd512de8/646bf43cf2e51f66cde218a9/OP_Logo.svg',
      logoAlt: 'Origin Point Logo',
      logoHeight: 32,
      logoWidth: 167,
      links: [{
        desktop: {
          linkName: 'Apply Now',
          linkUrl: '/api/redirect?dest=https://apply.originpoint.com'
        },
        mobile: {
          linkName: 'Apply Now',
          linkUrl: '/api/redirect?dest=https://apply.originpoint.com'
        }
      }, {
        desktop: {
          linkName: 'Sign In',
          linkUrl: 'https://my.originpoint.com/'
        },
        mobile: {
          linkName: 'Sign In',
          linkUrl: 'https://my.originpoint.com/'
        }
      }]
    },
    sameDayBanner: {
      sameDayBannerDesktopImageUrl: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltb8e41ad21daaa3c6/65666df052b29ba8465c1123/PowerBid_Couple_flat.webp',
      sameDayBannerDesktopImageHeight: 280,
      sameDayBannerDesktopImageWidth: 361,
      sameDayBannerBrandLogo: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltcf6fd0b2934b7d7f/64f7a88bec93376d99ec4d4d/samedaylogo-op.png',
      sameDayBannerBrandLogoHeight: 56,
      sameDayBannerBrandLogoWidth: 120,
      sameDayBannerSplitColor: '',
      // No split color
      sameDayBannerBgColor: 'var(--color-secondary-action-lightest)',
      sameDayBannerCorners: true,
      sameDayBannerPadding: 'var(--space-xy-xxSmall-rem) var(--space-xy-small-rem)'
    },
    helocBanner: {
      helocBannerIconName: '',
      helocBannerHeadingVariant: 'bodyL',
      helocBannerBgColor: 'var(--color-marketing-8-base)',
      helocBannerHeading: 'A HELOC just for you',
      helocBannerCtaColor: 'var(--color-primary-brand-base)',
      helocBannerHeadingFontSize: 'var(--font-size-m)',
      helocBannerPadding: 'var(--space-xy-xxSmall-rem) var(--space-xy-small-rem)'
    },
    personalLoanBanner: {
      personalLoanBannerIconName: '',
      personalLoanBannerHeadingVariant: 'bodyL',
      personalLoanBannerBgColor: 'var(--color-primary-brand-base)',
      personalLoanBannerParagraph: 'Powered by our affiliate partner, Rate, Inc.*',
      personalLoanBannerCtaColor: 'var(--color-primary-brand-base)',
      personalLoanBannerDisclaimer: '*This is a loan product referral and not offered by OriginPoint.',
      personalLoanBannerRedirectionPath: 'lp/personal-loans-op',
      personalLoanBannerPadding: 'var(--space-xy-xxSmall-rem) var(--space-xy-small-rem)',
      personalLoanBannerHeadingFontSize: 'var(--font-size-m)'
    },
    loGrid: {
      defaultImage: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt64ccc5340f9af7c2/64b58dfc9228cdcde97fe6ac/op-branch-image.webp'
    },
    carousel: {
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate',
        link: '/resources/home-down-payment-assistance'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down',
        link: '/resources/average-down-payment-for-a-house'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember',
        link: '/mortgage-rates/assumptions/va_30-year_fixed_conforming'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo',
        link: '/home-loans/jumbo-mortgage'
      }, {
        title: 'Lock in your rate',
        content: 'Lock ‘N’ Roll: Lock in a mortgage rate for 60, 75, or 90 days without a signed contract. Secure a lower rate while house shopping with this program.',
        iconName: 'performance-bar-percent',
        link: '/lock-n-roll'
      }, {
        title: 'Accelerated timelines',
        content: 'Our Same-Day program facilitates you to get your loan approved in one day with options as little as 3% down.',
        iconName: 'performance-path',
        link: '/same-day-mortgage'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health',
        link: '/resources/doctor-program'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }]
    },
    mortgageCalculatorTile: {
      isEnabledOnVpPage: false
    },
    firstTimeHomeBuyerTile: {
      isEnabledOnVpPage: false,
      isEnabledOnBranchPage: false
    },
    mortgageCalculatorLite: {
      mortgageCalculatorLiteDisclaimerText: "\n        <p>*This is not a commitment to lend. Consumers are advised to obtain a Loan Estimate. Rates are subject to change and are dependent on\n        credit and underwriting criteria.</p>\n\n        <p>Your actual rate, payment and costs could be higher. OriginPoint LLC cannot predict where rates\n        will be in the future. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other financial\n        advice specific to the circumstances of any individual and should not be relied upon in that regard. Applicant subject to credit and\n        underwriting approval. Not all applicants will be approved for financing. Receipt of application does not represent an approval for\n        financing or interest rate guarantee. Restrictions may apply, contact OriginPoint LLC for current\n        rates and for more information. All information provided in this publication is for informational and educational purposes only, and in\n        no way is any of the content contained herein to be construed as financial, investment,or legal advice or instruction.\n        OriginPoint LLC does not guarantee the quality, accuracy, completeness or timelines of the\n        information in this publication. While efforts are made to verify the information provided, the information should not be assumed to\n        be error free. Some information in the publication may have been provided by third parties and has not necessarily been verified by\n        OriginPoint LLC. OriginPoint LLC its affiliates and\n        subsidiaries do not assume any liability for the information contained herein, be it direct, indirect, consequential, special, or\n        exemplary, or other damages whatsoever and howsoever caused, arising out of or in connection with the use of this publication or in\n        reliance on the information, including any personal or pecuniary loss, whether the action is in contract, tort (including negligence)\n        or other tortious action. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other\n        financial advice specific to the circumstances of any individual and should not be relied upon in that regard.</p>\n      "
    }
  },
  cer: {
    useMinimalHeader: true,
    branchImage: 'https://images-cs.rate.com/v3/assets/blt8e9faa477962657a/blt4d33f092f511d416/65fb39700c744d25eb7c2a24/cer_default_headshot.png',
    heroImage: 'https://images-cs.rate.com/v3/assets/blt8e9faa477962657a/blt4d33f092f511d416/65fb39700c744d25eb7c2a24/cer_default_headshot.png',
    sameDayBanner: {
      sameDayBannerDesktopImageUrl: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltb8e41ad21daaa3c6/65666df052b29ba8465c1123/PowerBid_Couple_flat.webp',
      sameDayBannerDesktopImageHeight: 280,
      sameDayBannerDesktopImageWidth: 361,
      sameDayBannerHeading: 'So easy. So fast.',
      sameDayBannerParagraph: 'Same Day Mortgage removes the uncertainty from buying a home. Get your loan approved in one day with options as little as 3% down.',
      sameDayBannerCtaText: 'Learn more',
      sameDayBannerBrandLogo: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt02e92b0a75a65e34/65e7b6727756f68cdbf63740/same-day-mortgage-logo.png',
      sameDayBannerBrandLogoHeight: 51,
      sameDayBannerBrandLogoWidth: 96,
      sameDayBannerBgColor: '--color-secondary-input-white',
      sameDayBannerBorder: true,
      sameDayBannerCorners: true
    },
    personalLoanBanner: {
      personalLoanBannerParagraph: 'Powered by our affiliate partner, Rate, Inc. This is a loan product referral and not offered by Certainty Home Lending',
      personalLoanBannerBgColor: 'var(--color-primary-brand-base)',
      personalLoanBannerRedirectionPath: 'lp/personal-loans-certainty'
    },
    loGrid: {
      defaultImage: 'https://images-cs.rate.com/v3/assets/blt8e9faa477962657a/blt4d33f092f511d416/65fb39700c744d25eb7c2a24/cer_default_headshot.png'
    },
    carousel: {
      isEnabled: true,
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo'
      }, {
        title: 'Accelerated timelines',
        content: 'Our Same-Day program facilitates you to get your loan approved in one day with options as little as 3% down.',
        iconName: 'performance-path'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }, {
        title: 'Reverse Mortgages',
        content: 'A great option for homeowners over 62 who need additional income to supplement their retirement income or pay for long-term care.',
        iconName: 'money-hold',
        link: '/reverse-mortgage'
      }]
    },
    mortgageCalculatorTile: {
      mortgageCalculatorTileUrl: '/mortgage-calculator'
    },
    firstTimeHomeBuyerTile: {
      firstTimeHomeBuyerTileUrl: '/first-time-homebuyer'
    },
    minimalHeader: {
      isEnabled: true,
      logoSrc: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt1656872e8b4a00bb/65e122bd0f1d353d16ca576b/CertaintyHomeLending_Logo_Color.png',
      logoAlt: 'Certainty Logo',
      logoHeight: 52,
      logoWidth: 180,
      logoMobile: {
        src: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt8e4ba9e7457c762b/65f4c12dd957609d4d50607a/CertaintyHomeLending_Logo_Color@2x.svg',
        alt: 'Certainty Logo (mobile)',
        width: 124,
        height: 36
      },
      links: [{
        desktop: {
          buttonStyle: 'secondary',
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'APPLY NOW',
          linkUrl: '/api/redirect?dest=https://apply.certaintyhomelending.com/apply/loan-purpose',
          filterIfUncookied: true,
          addEmpIdParam: true
        },
        mobile: {
          buttonStyle: 'secondary',
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'APPLY NOW',
          linkUrl: '/api/redirect?dest=https://apply.certaintyhomelending.com/apply/loan-purpose',
          filterIfUncookied: true,
          addEmpIdParam: true
        }
      },
      // {
      //   desktop: {
      //     fontWeight: 'var(--font-weight-bold)',
      //     linkName: '(000) 000-0000',
      //     linkUrl: '',
      //     filterIfUncookied: true,
      //     isPhoneLink: true
      //   },
      //   mobile: {
      //     fontWeight: 'var(--font-weight-bold)',
      //     iconName: 'phone',
      //     linkName: '',
      //     linkUrl: '',
      //     isPhoneLink: true,
      //     filterIfUncookied: true,
      //   }
      // },
      {
        desktop: {
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'LOG IN',
          linkUrl: 'https://login.certaintyhomelending.com'
        }
      }, {
        mobile: {
          fontWeight: 'var(--font-weight-bold)',
          iconName: 'user',
          linkName: '',
          linkUrl: 'https://login.certaintyhomelending.com'
        }
      }]
    },
    mortgageCalculatorLite: {
      mortgageCalculatorLiteDisclaimerText: "\n        <p>*This is not a commitment to lend. Consumers are advised to obtain a Loan Estimate. Rates are subject to change and are dependent on\n        credit and underwriting criteria.</p>\n\n        <p>Your actual rate, payment and costs could be higher. Certainty Home Lending cannot predict where rates\n        will be in the future. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other financial\n        advice specific to the circumstances of any individual and should not be relied upon in that regard. Applicant subject to credit and\n        underwriting approval. Not all applicants will be approved for financing. Receipt of application does not represent an approval for\n        financing or interest rate guarantee. Restrictions may apply, contact Certainty Home Lending for current\n        rates and for more information. All information provided in this publication is for informational and educational purposes only, and in\n        no way is any of the content contained herein to be construed as financial, investment,or legal advice or instruction.\n        Certainty Home Lending does not guarantee the quality, accuracy, completeness or timelines of the\n        information in this publication. While efforts are made to verify the information provided, the information should not be assumed to\n        be error free. Some information in the publication may have been provided by third parties and has not necessarily been verified by\n        Certainty Home Lending. Certainty Home Lending its affiliates and\n        subsidiaries do not assume any liability for the information contained herein, be it direct, indirect, consequential, special, or\n        exemplary, or other damages whatsoever and howsoever caused, arising out of or in connection with the use of this publication or in\n        reliance on the information, including any personal or pecuniary loss, whether the action is in contract, tort (including negligence)\n        or other tortious action. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other\n        financial advice specific to the circumstances of any individual and should not be relied upon in that regard.</p>\n      "
    }
  },
  cit: {
    useMinimalHeader: true,
    branchImage: 'https://images-cs.rate.com/v3/assets/bltb30691d69e38e7b0/blt698d5fffdcb00f7c/65fb399e1732151e4fd2d9f7/cw-default-headshot.png',
    heroImage: 'https://images-cs.rate.com/v3/assets/bltb30691d69e38e7b0/blt698d5fffdcb00f7c/65fb399e1732151e4fd2d9f7/cw-default-headshot.png',
    sameDayBanner: {
      isEnabled: false
    },
    personalLoanBanner: {
      personalLoanBannerParagraph: 'Powered by our affiliate partner, Rate, Inc. This is a loan product referral and not offered by Citywide Home Mortgage',
      personalLoanBannerBgColor: 'var(--color-primary-brand-base)',
      personalLoanBannerRedirectionPath: 'lp/personal-loans-citywide'
    },
    loGrid: {
      defaultImage: 'https://images-cs.rate.com/v3/assets/bltb30691d69e38e7b0/blt698d5fffdcb00f7c/65fb399e1732151e4fd2d9f7/cw-default-headshot.png'
    },
    carousel: {
      isEnabled: true,
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo'
      }, {
        title: 'Accelerated timelines',
        content: 'Our Same-Day program facilitates you to get your loan approved in one day with options as little as 3% down.',
        iconName: 'performance-path'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }]
    },
    mortgageCalculatorTile: {
      mortgageCalculatorTileUrl: '/mortgage-calculator'
    },
    firstTimeHomeBuyerTile: {
      firstTimeHomeBuyerTileUrl: '/loan-options/fha/'
    },
    minimalHeader: {
      isEnabled: true,
      logoSrc: 'https://images-cs.rate.com/v3/assets/bltb30691d69e38e7b0/bltc4498c168d981fd2/663bea885f248547c4d0dae8/cw_hm_lines_small.jpg',
      logoAlt: 'City Logo',
      logoHeight: 56,
      logoWidth: 168,
      logoMobile: {
        src: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt80f55b54af9288ad/65e790d17ca220f6ee1e4c51/logo-monogram.svg',
        alt: 'CityWide logo (mobile)',
        width: 50,
        height: 78
      },
      links: [{
        desktop: {
          iconName: 'chevron-circle-right',
          linkName: 'Apply Now',
          linkUrl: '/api/redirect?dest=https://apply.citywidehm.com',
          filterIfUncookied: true,
          addEmpIdParam: true,
          additionalStyles: {
            marginLeft: 'var(--space-xy-small-rem)',
            width: 'max-content',
            gap: 'var(--space-xy-xxxSmall-rem)'
          }
        },
        mobile: {
          buttonStyle: 'quaternary',
          iconName: 'chevron-circle-right',
          linkName: 'Apply Now',
          linkUrl: '/api/redirect?dest=https://apply.citywidehm.com',
          filterIfUncookied: true,
          addEmpIdParam: true,
          additionalStyles: {
            marginLeft: 'var(--space-xy-small-rem)',
            width: 'max-content',
            gap: 'var(--space-xy-xxxSmall-rem)'
          }
        }
      },
      // { @TODO: to be added later, waiting to hear back from Product Team on URL
      //   desktop: {
      //     fontWeight: 'var(--font-weight-bold)',
      //     iconName: 'magnifying-glass-search',
      //     linkName: 'Search',
      //     linkUrl: 'https://login.citywidehm.com',
      //     additionalStyles: {
      //       marginLeft: 'var(--space-xy-small-rem)',
      //       width: 'max-content',
      //       gap: 'var(--space-xy-xxxSmall-rem)',
      //     }
      //   }
      // },
      {
        desktop: {
          iconName: 'user',
          linkName: 'Sign In',
          linkUrl: 'https://my.citywidehm.com',
          additionalStyles: {
            marginLeft: 'var(--space-xy-small-rem)',
            width: 'max-content',
            gap: 'var(--space-xy-xxxSmall-rem)'
          }
        },
        mobile: {
          iconName: 'user',
          linkName: '',
          linkUrl: 'https://my.citywidehm.com'
        }
      }],
      phoneLinkstyles: {
        fontWeight: 'var(--font-weight-regular)'
      }
    },
    mortgageCalculatorLite: {
      isEnabled: false
    }
  },
  kbhs: {
    useMinimalHeader: true,
    branchImage: 'https://images-cs.rate.com/v3/assets/bltbb12f746c5a4cc8e/blt336c8003f61a8da3/65fb39b2d4e0c07bf3294184/kbhs-default-headshot.png',
    heroImage: 'https://images-cs.rate.com/v3/assets/bltbb12f746c5a4cc8e/blt336c8003f61a8da3/65fb39b2d4e0c07bf3294184/kbhs-default-headshot.png',
    sameDayBanner: {
      isEnabled: false
    },
    helocBanner: {
      isEnabled: false
    },
    personalLoanBanner: {
      isEnabled: false
    },
    loGrid: {
      defaultImage: 'https://images-cs.rate.com/v3/assets/bltbb12f746c5a4cc8e/blt336c8003f61a8da3/65fb39b2d4e0c07bf3294184/kbhs-default-headshot.png'
    },
    carousel: {
      isEnabled: true,
      cards: [{
        title: 'Down payment assistance',
        content: 'Overcoming the obstacle of a down payment is possible with grants and programs available from federal and local governments for homeownership.',
        iconName: 'money-consolidate'
      }, {
        title: 'Low down payment loans',
        content: 'As the initial home investment, we offer VA loans, FHA loans, and USDA loans which have 0-10% down payment requirements.',
        iconName: 'home-down'
      }, {
        title: 'Veteran loans',
        content: 'Military service members and their families are in the unique position to build equity through real estate at a lower cost than typical homebuyers.',
        iconName: 'government-servicemember'
      }, {
        title: 'Bank Statement loans',
        content: 'Self-employed? Our Bank Statement Loan program allows self-employed borrowers to seek a home loan without tax returns, W2s or pay stubs.',
        iconName: 'document-financial'
      }, {
        title: 'Jumbo loans',
        content: 'You may consider this type if you plan to purchase a larger property or luxury home in high-end real estate markets.',
        iconName: 'home-jumbo'
      }, {
        title: 'Physician loans',
        content: 'Physician homes loan, can be an affordable option for medical professionals. Our program includes paid mortgage insurance and as little as 5% down.',
        iconName: 'wellness-human-health'
      }, {
        title: 'Foreign National loans',
        content: 'Not a US Citizen? Foreign National loans are available without a social security number, green card, or visa and do not require a FICO score.',
        iconName: 'travel-suitcase'
      }]
    },
    mortgageCalculatorTile: {
      mortgageCalculatorTileUrl: '/mortgage-calculator'
    },
    firstTimeHomeBuyerTile: {
      firstTimeHomeBuyerTileUrl: '/learning-center/insight/2022/your-guide-to-new-home-financing/'
    },
    minimalHeader: {
      isEnabled: true,
      logoSrc: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt6576ddfb089963ce/65f4c73d6119725859646204/Light_Background@2x.png',
      logoAlt: 'KBHS Logo',
      logoHeight: 50,
      logoWidth: 78,
      logoMobile: {
        src: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltbeb2bffeea2c42bc/65e103583e2d0e6de2f7218d/Light_Background@1x.png',
        alt: 'CityWide logo (mobile)',
        width: 65,
        height: 40
      },
      links: [{
        desktop: {
          buttonStyle: 'secondary',
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'Apply now',
          linkUrl: '/api/redirect?dest=https://apply.kbhshomeloans.com&loan-purpose=purchase&purchase-needs=beginning-to-look',
          filterIfUncookied: true,
          addEmpIdParam: true
        },
        mobile: {
          buttonStyle: 'quaternary',
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'Apply now',
          linkUrl: '/api/redirect?dest=https://apply.kbhshomeloans.com&loan-purpose=purchase&purchase-needs=beginning-to-look',
          filterIfUncookied: true,
          addEmpIdParam: true
        }
      }, {
        desktop: {
          fontWeight: 'var(--font-weight-bold)',
          linkName: 'LOG IN',
          iconName: '',
          linkUrl: 'https://login.kbhshomeloans.com'
        },
        mobile: {
          fontWeight: 'var(--font-weight-bold)',
          linkName: '',
          iconName: 'user-circle',
          linkUrl: 'https://login.kbhshomeloans.com'
        }
      }]
    },
    mortgageCalculatorLite: {
      mortgageCalculatorLiteDisclaimerText: "\n        <p>*This is not a commitment to lend. Consumers are advised to obtain a Loan Estimate. Rates are subject to change and are dependent on\n        credit and underwriting criteria.</p>\n\n        <p>Your actual rate, payment and costs could be higher.  KBHS Home Loans, LLC cannot predict where rates\n        will be in the future. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other financial\n        advice specific to the circumstances of any individual and should not be relied upon in that regard. Applicant subject to credit and\n        underwriting approval. Not all applicants will be approved for financing. Receipt of application does not represent an approval for\n        financing or interest rate guarantee. Restrictions may apply, contact  KBHS Home Loans, LLC for current\n        rates and for more information. All information provided in this publication is for informational and educational purposes only, and in\n        no way is any of the content contained herein to be construed as financial, investment,or legal advice or instruction.\n         KBHS Home Loans, LLC does not guarantee the quality, accuracy, completeness or timelines of the\n        information in this publication. While efforts are made to verify the information provided, the information should not be assumed to\n        be error free. Some information in the publication may have been provided by third parties and has not necessarily been verified by\n         KBHS Home Loans, LLC.  KBHS Home Loans, LLC its affiliates and\n        subsidiaries do not assume any liability for the information contained herein, be it direct, indirect, consequential, special, or\n        exemplary, or other damages whatsoever and howsoever caused, arising out of or in connection with the use of this publication or in\n        reliance on the information, including any personal or pecuniary loss, whether the action is in contract, tort (including negligence)\n        or other tortious action. Sample rate provided for illustration purposes only and is not intended to provide mortgage or other\n        financial advice specific to the circumstances of any individual and should not be relied upon in that regard.</p>\n      ",
      mortgageCalculatorLiteCtaButtonText: 'Apply now'
    }
  }
};

/* eslint-disable max-len */

/* eslint-disable @typescript-eslint/no-var-requires */
var merge = require$$0__default["default"];
var themeConfig = themeConfig$1;
var CMS_API_PATH_NO_PREFIX = 'cms-api';
var CMS_API_PATH = "/".concat(CMS_API_PATH_NO_PREFIX);
var YEXT_HOSTED_BRANDS = ['gri', 'op', 'gra', 'prate', 'cer', 'kbhs', 'cit'];
var APP_API_PATH = '/api';

/**
 * This file is for values for all properties.
 * @docs: https://github.com/node-config/node-config#readme
 */
var defaultConfig = {
  // APP AND BUILD CONSTANTS. Use getStaticConfig to access. These MAY NOT vary by brand.
  // This is where new brands are added to the application. See Adding New Brands in sb dev docs.
  BRANDS: [].concat(YEXT_HOSTED_BRANDS, ['morn', 'ent', 'own']),
  YEXT_HOSTED_BRANDS: YEXT_HOSTED_BRANDS,
  // This is header that is checked to determine brand from requests
  BRAND_HEADER: 'X-GR-Brand',
  // The brand to default to if no brand is found, only used for local dev, env var below will override
  DEFAULT_BRAND: 'gri',
  // The env var to use to override local dev brand
  BRAND_ENV_VAR: 'GR_BRAND',
  // All the generated CSS files to be included per tenant/theme.
  BRAND_CSS_FILE_NAMES: ['vars', 'font-faces'],
  // List of supported locales
  LOCALES: ['en', 'es'],
  INCEPTION_RUNNER: 'https://inception-runner.dev.saas.rate.com',
  REDIRECTION_UPLOAD: '/api/v1/synchronous/bulk-content-create',
  // The default locale we use if their browser locale doens't match supported list
  DEFAULT_LOCALE: 'en',
  CODE_PREFIX: 'rc',
  GRI_APP_URL: 'https://www.rate.com',
  NEXT_INTERNAL_PATHS_REGEX: /\/((_next|favicon.ico).*)/,
  BRANCHES_PATH: '/branches',
  LO_PATH: '/loan-officers',
  CMS_API_PATH: CMS_API_PATH,
  APP_API_PATH: APP_API_PATH,
  QUERY_PARAMS_SUB_ID: ['sub-id', 'sub_id'],
  QUERY_PARAMS_ADTRK: ['adtrk'],
  QUERY_PARAMS_LOID: ['loid', 'emp-id', 'emp_id'],
  VP_DATA_API_PATH: "".concat(APP_API_PATH, "/vpdata"),
  // An endpoint that proxies the rem through MOD and the CMS. It's for read only operations,
  // So using the prod domain for all envs is safe.
  CMS_REM_URL: "https://www.rate.com".concat(CMS_API_PATH, "/rem"),
  // OTHER VARS that vary by brand. Please use the normal getConfig for these.
  aimtell: 'https://api.aimtell.com',
  birdEyeId: '987654321301015183',
  loanService: {
    host: 'http://loan-service-dev-url.com'
  },
  googleMapsApi: {
    url: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyCVarbPudKoN48-Id5OSc2Wvcf1LHiu-HQ&libraries=places'
  },
  mortgageRateTrends: {
    url: "".concat(APP_API_PATH, "/mortgage-rates/trends")
  },
  superAppQRCode: {
    appStoreImageHeight: 50,
    appStoreImageWidth: 165,
    nfsGateway: {
      url: 'https://dev.fsp.rate.com/gateway/graphql'
    }
  },
  adwerx: {
    url: 'https://pixel.adwerx.com',
    account: 'rate',
    pathSuffix: 'awp.js'
  },
  jornaya: {
    accountCode: 'd3b3c17b-dead-1ec4-33fa-6f7426b3d326',
    campaignId: 'ac46fc2d-aba5-1faa-6650-210799ebd94a',
    lidstatic: 'create.lidstatic.com'
  },
  oktaApi: {
    host: 'https://gr.oktapreview.com'
  },
  // The `contentStack` prop here is merged with the native next one
  contentStack: {
    imageDomain: {
      orig: 'images.contentstack.io',
      transform: 'images-cs.rate.com'
    },
    assetDomain: {
      orig: 'assets.contentstack.io',
      transform: 'assets-cs.rate.com'
    },
    referenceFetchingOptions: {
      referenceInclusionPaths: ['children.child.reference.children.child.reference.children.child.reference.children.child.reference'],
      maxReferenceDepth: 50
    },
    brandsByApiKey: {
      // Rate.Com-Dev stack. This is for testing contentstack app changes.
      blta0a0e2cbebd2fad8: 'dev',
      bltc25aaac59a216364: 'gra',
      blt4bf507db5c9bc5ae: 'gri',
      blt5737aa238a6ee996: 'op',
      bltc202ce98e53c55ea: 'prate'
    }
  },
  pricingService: {
    uri: 'https://pricing-service.dev.saas.rate.com'
  },
  pricingToolkit: {
    uri: 'https://pricing-toolkit.dev.saas.rate.com'
  },
  redisHost: 'master.rate-com-dev.wigqhd.use1.cache.amazonaws.com',
  yext: {
    // defaults to GRI
    url: 'https://api.yext.com/v2',
    searchApiKey: 'd74257f5f492c916882c1f56c00b1592',
    experienceKey: 'guaranteed_rate',
    branchesPath: '/branches',
    loPath: '/loan-officers'
  },
  gri: {
    brandAbbreviation: 'gri',
    brandDomain: 'Rate.com',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/1ca2c647e075/launch-b1c63687b184-development.min.js',
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-gri-cardinal',
    loanService: {
      host: 'http://http://loan-service-dev-url-gri.com'
    },
    yext: {
      searchApiKey: 'd74257f5f492c916882c1f56c00b1592',
      experienceKey: 'guaranteed_rate'
    },
    pricingService: {
      tenantId: 'GRI',
      originatorUsername: 'DefaultConsumer2@rate.com'
    },
    prodUrl: 'https://www.rate.com',
    dmx: {
      dmxRouteDestParam: 'https://apply-gri.dev.saas.rate.com'
    },
    cram: {
      url: 'https://cram-internal.dev.gri.rate.com',
      leadEndpoint: '/v2/lead'
    },
    cloudflare: {
      features: ['nextjs', 'imageProxying', 'vaLoans', 'queryParams', 'all', 'grInsurance', 'mortgageRates', 'legacyCms', 'homeValuation', 'rem', 'mortgageCalculator']
    },
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/bltb56256f0e773405d/667f47affcee4a1afe2dfda6/RATE.png?format=jpg&width=1200&height=491&quality=80',
      width: 1200,
      height: 491,
      alt: 'Rate logo'
    },
    company: 'Rate',
    defaultPageTitle: 'Mortgages, Loans, Home Buying, Refinance Mortgage Company | Rate',
    defaultPageDescription: 'Rate IL - Chicago - assists you with low cost home purchase and refinance mortgages, great service, and fast closings'
  },
  prate: {
    brandAbbreviation: 'prate',
    brandDomain: 'Properrate.com',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/d52ea1e5d8f8/launch-47470c5d6312-development.min.js',
    cloudflare: {
      features: ['all', 'grInsurance', 'homeValuation', 'legacyCms', 'mortgageCalculator', 'mortgageRates', 'nextjs', 'queryParams', 'rem', 'vaLoans']
    },
    loanService: {
      host: 'http://http://loan-service-dev-url-prate.com'
    },
    pricingService: {
      tenantId: 'PRATE',
      originatorUsername: 'PRDefault@proper.com'
    },
    prodUrl: 'https://www.properrate.com',
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-pr-mockingbi',
    dmx: {
      dmxRouteDestParam: 'https://apply.properrate.com'
    },
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt668a2ad6a92cc006/667f47afc66c889f7869ddcf/PRATE.png?format=jpg&width=1200&height=392&quality=80',
      width: 1200,
      height: 392,
      alt: 'Proper Rate logo'
    },
    company: 'Proper Rate',
    defaultPageTitle: 'Mortgages, Loans, Home Buying, Refinance Mortgage Company | Proper Rate',
    defaultPageDescription: 'Proper Rate - assists you with low cost home purchase and refinance mortgages, great service, and fast closings'
  },
  op: {
    brandAbbreviation: 'op',
    brandDomain: 'Originpoint.com',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/7fe1574707c6/launch-2d01acfa8227-development.min.js',
    pricingService: {
      tenantId: 'OP',
      originatorUsername: 'opdefault@rate.com'
    },
    adwerx: {
      account: 'originpoint'
    },
    cloudflare: {
      features: ['all', 'grInsurance', 'homeValuation', 'legacyCms', 'mortgageCalculator', 'mortgageRates', 'nextjs', 'queryParams', 'rem', 'vaLoans']
    },
    prodUrl: 'https://www.originpoint.com',
    dmx: {
      dmxRouteDestParam: 'https://apply-op.dev.saas.rate.com'
    },
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-op-bluebird',
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blte5f1bee656722e5e/667f47afee05f3649c3002d1/OP.png?format=jpg&width=1200&height=232&quality=80',
      width: 1200,
      height: 232,
      alt: 'OriginPoint logo'
    },
    company: 'OriginPoint',
    defaultPageTitle: 'Mortgages, Loans, Home Buying & Refinance Mortgage Company | OriginPoint',
    defaultPageDescription: 'OriginPoint assists you with a low cost home purchase, refinance mortgage & fast closings. See why OriginPoint is the best mortgage lender in the U.S.'
  },
  morn: {
    // TODO change when this becomes integrated by pricing service
    brandAbbreviation: 'morn',
    pricingService: {
      tenantId: 'GRI',
      originatorUsername: 'DefaultConsumer2@rate.com'
    }
  },
  gra: {
    brandAbbreviation: 'gra',
    brandDomain: 'Grarate.com',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/434b35f46f30/launch-bf041c995bb5-development.min.js',
    cloudflare: {
      features: ['all', 'grInsurance', 'homeValuation', 'legacyCms', 'mortgageCalculator', 'mortgageRates', 'nextjs', 'queryParams', 'rem', 'simon', 'vaLoans']
    },
    pricingService: {
      tenantId: 'GRA',
      originatorUsername: 'GRAdefault@grarate.com'
    },
    prodUrl: 'https://www.grarate.com',
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-gra-blue-jay',
    dmx: {
      dmxRouteDestParam: 'https://apply-gra.dev.saas.rate.com'
    },
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blta6df79ac5d0d3f22/667f47afb6a6c86ccb8fa51b/GRA.png?format=jpg&width=1200&height=320&quality=80',
      width: 1200,
      height: 320,
      alt: 'Guaranteed Rate Affinity logo'
    },
    company: 'Guaranteed Rate Affinity',
    defaultPageTitle: 'Guaranteed Rate Affinity',
    defaultPageDescription: 'Guaranteed Rate Affinity assists you with low cost home purchase and refinance mortgages, great service, and fast closings'
  },
  ent: {
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/enterprise-0-2'
  },
  own: {
    brandAbbreviation: 'own',
    prodUrl: 'https://www.owning.com',
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-own-starling'
  },
  cer: {
    brandAbbreviation: 'cer',
    brandDomain: 'Certaintyhomelending.com',
    cloudflare: {
      features: ['nextjs']
    },
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-certainty',
    prodUrl: 'https://www.certaintyhomelending.com',
    dmx: {
      dmxRouteDestParam: 'https://apply-certainty.dev.saas.rate.com'
    },
    company: 'Certainty Home Lending',
    defaultPageTitle: 'Certainty Home Lending | Mortgages, Loans, Homebuying, Refinancing, HELOC',
    defaultPageDescription: 'Certainty Home Lending has been helping homebuyers and homeowners for over 20 years, with a focus on providing a simple mortgage process and unparalleled customer service.',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/865171d34a69/launch-0f1809d1bfdb-development.min.js',
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt51bf81b86803e1f8/667f47aebbf7b4b18ba76003/CER.png?format=jpg&width=1200&height=354&quality=80',
      width: 1200,
      height: 354,
      alt: 'Certainty Home Lending logo'
    }
  },
  kbhs: {
    brandAbbreviation: 'kbhs',
    brandDomain: 'Kbhshomeloans.com',
    cloudflare: {
      features: ['nextjs']
    },
    prodUrl: 'https://www.kbhshomeloans.com',
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-kbhs',
    dmx: {
      dmxRouteDestParam: 'https://apply-kbhs.dev.saas.rate.com&loan-purpose=purchase&purchase-needs=beginning-to-look'
    },
    company: 'KBHS Home Loans',
    defaultPageTitle: 'Mortgages, Loans, Home Buying, Refinance Mortgage Company | KBHS Home Loans',
    defaultPageDescription: 'KBHS Home Loans - assists you with low cost home purchase and refinance mortgages, great service, and fast closings',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/b5d224c02bfa/launch-54337d73f546-development.min.js',
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt87a403552b8d0217/667f47af8a80d10cc6ade9d2/KBHS.png?format=jpg&width=1200&height=756&quality=80',
      width: 1200,
      height: 756,
      alt: 'KBHS Home Loans logo'
    }
  },
  cit: {
    brandAbbreviation: 'cit',
    brandDomain: 'Citywidehm.com',
    cloudflare: {
      features: ['nextjs']
    },
    prodUrl: 'https://www.citywidehm.com',
    dsmUrl: 'https://guaranteedrate.invisionapp.com/dsm-export/guaranteed-rate/consumer-citywide',
    dmx: {
      dmxRouteDestParam: 'https://apply-citywide.dev.saas.rate.com'
    },
    company: 'Citywide Home Mortgage',
    defaultPageTitle: 'Mortgages, Loans, Home Buying, Refinance Mortgage Company | Citywide Home Mortgage',
    defaultPageDescription: 'Citywide Home Mortgage - assists you with low cost home purchase and refinance mortgages, great service, and fast closings',
    adobeLaunchUrl: 'https://assets.adobedtm.com/dc28b7578231/1722fb8d7f67/launch-e641f67b3440-development.min.js',
    openGraphDefaultImage: {
      url: 'https://images-cs.rate.com/v3/assets/blt4bf507db5c9bc5ae/blt8f014e393d68ece3/667f47afc66c886f5969ddcb/CIT.png?format=jpg&width=1200&height=248&quality=80',
      width: 1200,
      height: 248,
      alt: 'Citywide Home Mortgage logo'
    }
  }
};

// Deeply merging themeConfig object into defaultConfig. If a property with the same key is present for both objects, the value from defaultConfig will prevail.
var _default = merge(themeConfig, defaultConfig);

/**
 * Get a static config object from default config w/o uppercasing.
 *
 * Returns undefined if not found.
 *
 * @param configKey a key that will not be uppercased.
 * @returns any
 */
var getDefaultConfig = function getDefaultConfig(configKey) {
  return _default[configKey] || undefined;
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var stripEmptyAttrs = function stripEmptyAttrs(attrs) {
  return Object.keys(attrs).reduce(function (accum, key) {
    return attrs[key] ? _objectSpread$1(_objectSpread$1({}, accum), _defineProperty__default["default"]({}, key, attrs[key])) : accum;
  }, {});
};
var prefix = getDefaultConfig('CODE_PREFIX');
var prepAttributes = function prepAttributes(iconName, style, className) {
  return {
    className: "".concat(prefix, "-font-icon font-icons-").concat(iconName).concat(className ? " ".concat(className) : ''),
    'aria-hidden': true,
    style: stripEmptyAttrs(_objectSpread$1({}, style))
  };
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var propTypes = {
  /** The name of the icon. Must match one of the listed icons */
  iconName: PropTypes__default["default"].string.isRequired,
  /** Additional styles to add to the icon. */
  styles: PropTypes__default["default"].objectOf(PropTypes__default["default"].string),
  // TODO: use stronger type?
  /** Padding to add to the icon. */
  padding: PropTypes__default["default"].string,
  /** fontSize of the icon. */
  fontSize: PropTypes__default["default"].string,
  /** Additional classes to add to the icon. */
  className: PropTypes__default["default"].string
};
/**
 * This is mostly a convenient react container for the i tag with attrs.
 */
var FontIcon = function FontIcon(_ref) {
  var iconName = _ref.iconName,
    styles = _ref.styles,
    padding = _ref.padding,
    fontSize = _ref.fontSize,
    className = _ref.className;
  var attrs = prepAttributes("".concat(iconName), _objectSpread({
    fontSize: fontSize,
    padding: padding
  }, styles), className || '');
  return /*#__PURE__*/jsxRuntime.jsx("i", _objectSpread({
    "data-testid": "font-icon"
  }, attrs));
};
FontIcon.propTypes = propTypes;

exports["default"] = FontIcon;
